export const environment = {
    production: true,
    trackingAPIURL: 'https://tracking.drivendelivery.co.uk/api/Tracking/get',
    eBayRegEx: '^\d{2}-\d{5}-\d{5}$',
    AmazonRegEx: '^\d{3}-\d{7}-\d{7}}$',
    SONumberRegEx: '^\d{8-10}$',
    GUIDRegEx: '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
};
